import React from 'react';
import { Mail, Phone, MapPin, Clock } from 'lucide-react';

const ContactUs = () => {
  return (
    <div className="pt-20">
      {/* Hero Section with Background */}
      <section className="relative min-h-[60vh] flex items-center justify-center bg-white">
        {/* Background Image */}
        <div className="absolute inset-0 z-0 overflow-hidden">
          <img 
            src="https://images.unsplash.com/photo-1497366216548-37526070297c?q=80&w=2000"
            alt="Contact Us"
            className="w-full h-full object-cover animate-ken-burns"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/60"></div>
        </div>

        {/* Content */}
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-5xl md:text-6xl font-bold text-white mb-6 animate-fade-in-up" style={{ fontFamily: "'Playfair Display', serif" }}>
              Get in Touch
            </h1>
            <div className="flex items-center justify-center gap-4 mb-6 animate-fade-in">
              <div className="h-1 w-20 bg-[#B8944A] rounded"></div>
              <div className="w-3 h-3 bg-[#B8944A] rounded-full"></div>
              <div className="h-1 w-20 bg-[#B8944A] rounded"></div>
            </div>
            <p className="text-xl text-white/90 leading-relaxed animate-fade-in-up animation-delay-200">
              We're Here To Help You Find Your Dream Property
            </p>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-24 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center">Contact Information</h2>
            <p className="text-gray-600 leading-relaxed mb-12 text-center">
              Whether you're buying, selling, or investing in property, our team is ready to provide expert guidance every step of the way.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="flex gap-4">
                <div className="w-14 h-14 bg-[#B8944A]/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <MapPin className="text-[#B8944A]" size={24} />
                </div>
                <div>
                  <h3 className="font-bold text-gray-900 mb-2">Office Address</h3>
                  <p className="text-gray-600">0526/31, Sector-27, Techzone,<br />Greater Noida, Uttar Pradesh 201312</p>
                </div>
              </div>

              <div className="flex gap-4">
                <div className="w-14 h-14 bg-[#B8944A]/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <Phone className="text-[#B8944A]" size={24} />
                </div>
                <div>
                  <h3 className="font-bold text-gray-900 mb-2">Phone Number</h3>
                  <a href="tel:+919999505420" className="text-gray-600 hover:text-[#B8944A] transition-colors block">+91 99995 05420</a>
                  <a href="tel:+917838486828" className="text-gray-600 hover:text-[#B8944A] transition-colors block">+91 78384 86828</a>
                </div>
              </div>

              <div className="flex gap-4">
                <div className="w-14 h-14 bg-[#B8944A]/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <Mail className="text-[#B8944A]" size={24} />
                </div>
                <div>
                  <h3 className="font-bold text-gray-900 mb-2">Email Address</h3>
                  <p className="text-gray-600">
                    <a href="mailto:bhagatpropbuilt@gmail.com" className="hover:text-[#B8944A]">bhagatpropbuilt@gmail.com</a>
                  </p>
                </div>
              </div>

              <div className="flex gap-4">
                <div className="w-14 h-14 bg-[#B8944A]/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <Clock className="text-[#B8944A]" size={24} />
                </div>
                <div>
                  <h3 className="font-bold text-gray-900 mb-2">Business Hours</h3>
                  <p className="text-gray-600">Monday - Friday: 9:00 AM - 6:00 PM<br />Saturday: 10:00 AM - 4:00 PM</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Map Section */}
      <section className="h-[500px] bg-gray-200">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3509.944053698403!2d77.5251279793457!3d28.39075770000002!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390cc100f335147d%3A0x5e0f3f11ba7afafa!2sBhagat%20prop%20built!5e0!3m2!1sen!2sin!4v1772016994468!5m2!1sen!2sin"
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Bhagat Prop Built - Greater Noida"
        ></iframe>
      </section>
    </div>
  );
};

export default ContactUs;
